import React from "react";
import { Column, ColumnContainer, LoadingContainer, SectionTitle, TitleContainer, CardSlider } from "@beacharound/beacharound-ui";
import { getCities } from "../../../api/places";
import { useQuery } from "react-query";
import { getPlaceholderImage } from "../../../helpers/images/getPlaceholderImage";
import { Fragment } from "react";
import { Link } from "react-router-dom";

export default function CitiesHighlight({districtSlug, match, home}) {

    const isHotel = match.url.includes('i-migliori-hotel')

    const { data: cities, isLoading: isLoadingCities } = useQuery(["cities"], () =>
        getCities({
            params: {
                district: districtSlug,
                params: {
                    cover: home && { $exists: true }
                },
                sort: {"highlight.fromDate": -1}
            }
        }),
        {
            refetchOnWindowFocus: false
        }
    );

    const parsedCities = cities?.map((item) => {
        return {
            description: item.name,
            image: item.cover || getPlaceholderImage(isHotel ? 'hotels' : 'beaches'),
            noBorder: true,
            component: Link,
            to: `/luoghi/${item.slug}`
        }
    })

    if (cities?.length < 1) {
        return <Fragment></Fragment>
    }

    return (
        <LoadingContainer isLoading={isLoadingCities}>
            <TitleContainer>
                <SectionTitle text={`Scopri i migliori posti dove prenotare`} />
            </TitleContainer>
            <ColumnContainer>
                <Column>
                    <CardSlider slides={parsedCities} vertical shortSlides/>
                </Column>
            </ColumnContainer>
        </LoadingContainer>

    );
}